import { render, staticRenderFns } from "./SectionParameters.vue?vue&type=template&id=ae32332c&"
import script from "./SectionParameters.vue?vue&type=script&lang=js&"
export * from "./SectionParameters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports